import { validate as uuidValidate } from 'uuid';
import { DF, XIRGO_V1_VENDOR_ID, XIRGO_V2_VENDOR_ID } from './Vendors';

export const CONNECT_DISCONNECT_ID = '2aedf7c0-7072-11e6-9616-d1436e22fac1';
export const DF_PROVISIONING_MODEL_ID = '00000000-0000-0000-0000-000000000002';
export const MAINTENANCE_LOG_ID = '00000000-0000-0000-0000-000000000000';
export const NIL_UUID = '00000000-0000-0000-0000-000000000000';
export const PROVISIONING_MODEL_ID = '00000000-0000-0000-0000-000000000001';
export const PROVISIONING_MODEL_ORGID = '00000000-0000-0000-0000-000000000001';
export const START_PUMP_COMMAND_ID = '00000000-0000-0000-0000-000000000001';
export const STOP_PUMP_COMMAND_ID = '00000000-0000-0000-0000-000000000002';
export const SET_PUMP_RPM_COMMAND_ID = '00000000-0000-0000-0000-000000000003';
export const XIRGO_PROVISIONING_MODEL_ID =
  '00000000-0000-0000-0000-000000000003';
export const XIRGO_V2_PROVISIONING_MODEL_ID =
  '00000000-0000-0000-0000-000000000004';
export const XIRGO_STATIC_SIGNALS = [
  '10000000-0000-0000-0000-000000000001',
  '10000000-0000-0000-0000-000000000002',
  '10000000-0000-0000-0000-000000000003',
];
export const PROVISION_MODEL_ID_SET = new Set([
  DF_PROVISIONING_MODEL_ID,
  PROVISIONING_MODEL_ID,
  XIRGO_PROVISIONING_MODEL_ID,
  XIRGO_V2_PROVISIONING_MODEL_ID,
]);
export const HFX_FLASH_JOB_COMMAND_ID = '00000000-0000-0000-0000-000000000200';

export const PROVISION_MODEL_ID_MAP = new Map([
  [DF, DF_PROVISIONING_MODEL_ID],
  ['protobuf', PROVISIONING_MODEL_ID],
  ['json', PROVISIONING_MODEL_ID],
  [XIRGO_V1_VENDOR_ID, XIRGO_PROVISIONING_MODEL_ID],
  [XIRGO_V2_VENDOR_ID, XIRGO_V2_PROVISIONING_MODEL_ID],
]);

export function isValidNotNilUuid(uuid) {
  return uuidValidate(uuid) && uuid !== NIL_UUID;
}
